import { Box, InputAdornment, TextField } from "@mui/material";
import HistoryItem from "./HistoryItem";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import React, { useRef, useState, useEffect, useCallback, useContext } from "react";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import Delayed from "../../../utils/Delayed";
import CommunicationListItem from "../CommunicationList/CommunicaitonListItem";
import { PqCommunicationContext } from "../../../store/pqCommunication-context";
import { getOrgId } from "../../../utils/Token";
import BackBtn from "../Communication/Message/BackBtn";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";


const Data_LIMIT = 25; // number of histories to fetch at a time
const SCROLL_THRESHOLD = 100; // number of pixels from the bottom to trigger fetching more histories
let page = 1;
let isLoading = false;
let hasMore = true;
let totalPages = 1;

const HistoryTab = (props) => {
  const navigate = useNavigate();
  const [histories, setHistories] = useState([]);
  const [communications, setCommunications] = useState([]);
  const listContainerRef = useRef(null);
  const [searchStr, setSearchStr] = useState("");
  const [getHistory, setGetHistory] = useState(false);

  const { globalPqDetails, setGlobalPqDetails } = useContext(
    PqCommunicationContext
  );

  const handleBackClick = () => {


    props.onSelectCommunication(0);
    setGetHistory(!getHistory);
    setCommunications([]);
  };
  
  const handleItemClick = async (prequalificationId, vendorName, clientName) => {
    props.onSelectCommunication(prequalificationId);
    setGlobalPqDetails({ pqId: prequalificationId, vendorName, clientName });
    const orgId = getOrgId();
    if(prequalificationId > 0){
      const resp = await axios.get(BaseURL.baseUrl + BaseURL.widget.MarkNotificationsAsReadForPQ +"?orgId=" +orgId+"&pqId="+prequalificationId);
        
      if (resp?.data?.responseCode === -100) {
        toast.error(resp?.data?.data, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } 
    }
    setTimeout(() => {
      const params = new URLSearchParams(window.location.search);
      const PQID = params.get("pqid");
      if (PQID != prequalificationId) {
        navigate("/vendordetails?pqid=" + prequalificationId + "&tab=Questionnaire"+ "&Type=4");
      }
    }, 1000);

  };

  const fetchHistory = useCallback(async () => {
    if (isLoading || !hasMore) return;
    isLoading = true;
    try {
      let response;
      if (props.pqId !== 0) {
        response = await axios.get(
          BaseURL.baseUrl +
            BaseURL.widget.GetHistory +
            "?prequalificationId=" +
            props.pqId +
            "&pageSize=" +
            Data_LIMIT +
            "&pageNumber=" +
            page
        );
        if (response.status === 200) {
          if (response.data.data) {
            setHistories((prevHistories) => {
              const newHistories = response.data.data.filter(
                (history) =>
                  !prevHistories.some(
                    (prevHistory) => prevHistory.historyId === history.historyId
                  )
              );
              totalPages = Math.ceil(
                response.data?.data[0]?.totalHistories / Data_LIMIT
              );
              return [...prevHistories, ...newHistories];
            });
            if (response.data?.data?.length === 0) hasMore = false;
  
            isLoading = false;
          }
        }
      } else {
        response = await axios.get(
          BaseURL.baseUrl +
            BaseURL.widget.GetHistoryPQNotifications +
            "?searchValue=" +
            encodeURIComponent(searchStr) +
            "&pageSize=" +
            Data_LIMIT +
            "&pageNumber=" +
            page
        );

        if (response.status === 200) {
          if (response.data.data) {
            setCommunications((prevCommunications) => {
              // remove any duplicates from the new communications before adding them to the existing array
              const newCommunications = response.data.data.filter(
                (communication) =>
                  !prevCommunications.some(
                    (prevComm) =>
                      prevComm.emailRecordId ===
                      communication.emailRecordId
                  )
              );
              totalPages = Math.ceil(
                response.data?.data[0]?.totalHistories / Data_LIMIT
              );
              return [...prevCommunications, ...newCommunications];
            });
            if (response.data?.data?.length === 0) hasMore = false;    

            isLoading = false;
          }
        }
      }
    } catch (e) {
      console.error(e);
      isLoading = false;
    }
  }, [props.pqId, getHistory]);

  const debouncedSearch = _.debounce((value) => {
    setCommunications([]);
    setGetHistory(!getHistory)
  }, 1000);


  const handleOnSearchChange = (value) => {
    if (searchStr !== value.target.value) {
      setSearchStr(value.target.value);
      debouncedSearch(value.target.value);
    }
  };


  const handleScroll = useCallback(() => {
    const container = listContainerRef.current;
    const scrolledToBottom =
      container?.scrollTop + container.clientHeight >=
      container?.scrollHeight - SCROLL_THRESHOLD;
    if (scrolledToBottom) {
      if (!isLoading) {
        if (totalPages > page) {
          page = page + 1;
          fetchHistory();
        }
      }
    }
  }, [fetchHistory]);

  // attach scroll event listener when component mounts
  useEffect(() => {
    totalPages = 1;
    hasMore = true;
    page = 1;
    isLoading = false;
    fetchHistory();
    const container = listContainerRef.current;
    container?.addEventListener("scroll", handleScroll);
    return () => {
      isLoading = true;
      container?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, getHistory]);

  return (
    <>
      <Box
        className="px-3"
        ref={listContainerRef}
        style={{ height: "calc(77vh)", overflowY: "auto" }}
      >
        {props.pqId !== 0 ? (
            <BackBtn
              handleBackClick={handleBackClick}
              listTitle={globalPqDetails.vendorName}
              clientName={globalPqDetails.clientName}
            />
        ):
          <Box pt={2}>
            <TextField
              placeholder="Search"
              id="outlined-start-adornment"
              value={searchStr}
              sx={{ m: 1, width: "25ch" }}
              onChange={handleOnSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        }
        
        {props.pqId !== 0 ? (
          histories.length === 0 ? (
            <Delayed waitBeforeShow={2000}>
              <ErrorAlert severity="warning" message={"No results found!"} />
            </Delayed>
          ) : (
            histories.map((i, idx) => (
              <div className="list-item px-0" key={idx}>
                <HistoryItem
                  type={i.statusId}
                  comment={i.comment}
                  status={i.status}
                  notificationType={i.type}
                  createdBy={i.createdBy}
                  createdDate={i.createdDate}
                  isPQRenewable={i.isPQRenewable}
                  vendorId={i.vendorId}
                  isDocumentSpecific={i.isDocumentSpecific}
                  sectionId={i.sectionId}
                  prequalificationId={i.prequalificationId}
                />
              </div>
            ))
          )
        ) : (
          communications.length === 0 ? (
            <>
            {isLoading ? (<LoadingSpinner/>):            
              (
              <Delayed waitBeforeShow={2000}>
                {/* <ErrorAlert severity="warning" message={"No results found!"} /> */}
              </Delayed>
              )
            }
            </>
          ) : (
            communications.map((i, idx) => (
              <div className="list-item px-0" key={idx}>
                <CommunicationListItem {...i} handleItemClick={handleItemClick} />
              </div>
            ))
          )
        )}
      </Box>
    </>
  );
};
export default HistoryTab;
